if($("body").hasClass("template-product")){
          function initTerms() {
            $(document).on('change', '[data-terms-trigger]', function() {
              console.log("check on change")
                const action = $(this).attr('data-terms-trigger');
                const btn = $('[data-terms-action="'+action+'"]');
                if (btn) {
                    if ($(this).is(':checked')) {
                        btn.removeAttr('disabled');
                    } else {
                        btn.attr('disabled', true);
                    }
                }
            });
        }
  initTerms();
}

if ($(window).width() < 992) {
  $(".cm_slideshow_nav_btn").appendTo(".col-lg-7");
};
if ($(window).width() < 768) {
  $(".testimonial_slider_btn").appendTo(".mobi_slider_arrow");
};

$(document).on("click",".cm_search_input button",function() {
        var result = $(".cm_search_input input").val();
        var old_url = $(this).attr("data-search-url")   
        result = result.replace(/\s+/g, '+');
        window.location.replace(old_url+result);
});

$('.ft_click_btn').on("click",function(){
  $('html, body').animate({scrollTop:0}, 'slow');
  return false;
});
function shipping_carrier(params) {
     $(document).on('change', '.cart-cstm-info #shipping_carrier', function() {
          if ($(this).is(':checked')) {
                 $('.cart-cstm-info .inner_field').show();
              $('.cart-cstm-info #account_name').attr('required', true);
              $('.cart-cstm-info #account_number').attr('required', true);
          } else {
              $('.cart-cstm-info .inner_field').hide();
              $('.cart-cstm-info #account_name').removeAttr('required');
              $('.cart-cstm-info #account_number').removeAttr('required');
          }
    });
}
shipping_carrier();
$(document).ready(function(){
      

  
  var width = $(window).width();
  if(width < 768){
    $('.hytrol_manuals .mobile_tab').hide();
    setTimeout(function() {
      $(".hytrol_manuals .manual:first h4").trigger('click');
    }, 500);
    $(".hytrol_manuals .manual h4").click(function(event) {
        event.preventDefault()
      $(this).parent().toggleClass('active').find('.mobile_tab').slideToggle('fast');
      $(".hytrol_manuals .manuals_block .manual h4").not(this).parent().removeClass('active').find('.mobile_tab').slideUp('fast');
    });
  }
  
  $(document).on("click",'.collection-grid-section a.read_more',function(){
    $('.coll_desc_half').hide();
    $('.coll_desc_full').show();
    $(this).addClass('read_less');
    $(this).removeClass('read_more');
    $(this).text('Read Less');
  });
  $(document).on("click",'.collection-grid-section a.read_less',function(){
    $('.coll_desc_full').hide();
    $('.coll_desc_half').show();
    $(this).addClass('read_more');
    $(this).removeClass('read_less');
    $(this).text('Read More');
  });

  $(document).on('change','.cart__contents .cart__items .cart-item input[type="checkbox"]',function(){
    var check_length = $('.cart__contents .cart__items .cart-item input[type="checkbox"]:checked').length;
    console.log(check_length)
    if(check_length > 0){
      $('.cart__contents a.cart_all_remove_btn').removeClass('disable');
    }else{
      $('.cart__contents a.cart_all_remove_btn').addClass('disable');
    }
  });
  
  $(document).on('click','.cart__contents a.cart_all_remove_btn',function(){
    document.querySelectorAll('.loading-wrapper.loading-box')[0].classList.remove('hidden');
        var check_length = $('.cart__contents .cart__items .cart-item input[type="checkbox"]:checked').length;
         var updates = {
              updates: {}
        };
        for(var i=0;i<check_length;i++){
          var index = $('.cart__contents .cart__items .cart-item input[type="checkbox"]:checked').eq(i).attr('data-variant-id');
          updates['updates'][index] = 0;
        }
        
        $.ajax({
          url: "/cart/update.js",
          type: "POST",
          data: updates,
          dataType: "json",
          success: function (response) {
            location.reload();
          },
          error: function(error){
            console.log("error");
          }
        });    
  });
  
  $(document).on('click','.cart__contents .cart__items .cart-item .cart-item-details .add_note',function(){
    $(this).next('.cart__note').show();
    $(this).hide();
  });
// cstm collection filter
  $(document).on('click','.filter-tag li a', function(event) {
    event.preventDefault();
       // console.log("1")
    var tag_value = $(this).closest("li").attr("data-tag-value");  
    if(tag_value){
         $(this).closest("li").toggleClass("active");
          // console.log("tag_value",tag_value)
         $(".more-filters [data-value='" + tag_value + "']").trigger("click"); 
    } 
});
    $(document).on('click','.filter-tag li a.cstm_pro_type', function(event) {
    event.preventDefault();
    // console.log("2")
    var type_value = $(this).closest("li").attr("data-pro-type-value");  
      if(type_value){
           $(this).closest("li").toggleClass("active");
           // console.log("tag_value",type_value);
           $(".product-type [data-value='" + type_value + "']").trigger("click"); 
      }   
});
  
// popup show
  $(document).on('click','.popup_click', function(){
    $("body").toggleClass("popup_active")    
});
$("body").click(function(){
    var $target = $(event.target);
    if(!$target.is(".iner_content_contianer") && !$target.parents().is(".iner_content_contianer")){
        $("body").removeClass('popup_active');
    }
});
  //login poup
  // $(document).on('click','.custom_login_popup .tabs_login_register ul li', function(){
  //   var id = $(this).attr('data-tab');
  //   $('.custom_login_popup .tabs_login_register ul li').removeClass('active');
  //   $('.custom_login_popup .tabs_login_register').find('.tab_content').hide();
  //   $(this).addClass('active');
  //   $('.custom_login_popup .tabs_login_register').find('#'+id).show();
  // });
  
});
$("body").click(function(){
    var $target = $(event.target);
    if(!$target.is(".mfp-wrap") && !$target.parents().is(".mfp-wrap")){        
      $("body").removeClass("active-popup")
    }
});
$(".mfp-wrap .mfp-close").click(function() {
    $("body").removeClass("active-popup")
});
// Open cart Drawer then Close Menu Js
$('#navbarNav .cart a').click(function(){
   $('.back-wrapper.menu-close').click();
});

// Search input placeholder product active to disable megamenu
$('.rps-csb-container ._formContainer_12vbd_14 .rps-csb-input').focusin(function(){
    $('body').addClass('search_placeholder_pro_active')
});
$('.rps-csb-container ._formContainer_12vbd_14 .rps-csb-input').focusout(function(){
    $('body').removeClass('search_placeholder_pro_active')
});